import "core";
import "core.css";

import mount from "./mount-base";

export default mount;
